import type { ApiReferenceTranslations } from '@scalar/types/api-reference'

export const zhCn = {
  common: {
    streamItem: '流项目',
    description: '描述',
    httpMethod: 'HTTP 方法',
    path: '路径',
    copyDefault: '复制默认值',
    copyExample: '复制示例值',
  },
  search: {
    label: '搜索',
    inputLabel: '输入搜索查询',
    open: '打开搜索',
    placeholder: '搜索...',
    clear: '清除搜索',
    noResults: '未找到结果',
    keyboardShortcut: '键盘快捷键：',
    command: 'Command 键',
    control: 'Control 键',
    results: '参考文档搜索结果',
    navigate: '导航',
    select: '选择',
    instructions: '按上/下箭头导航，按 Enter 选择，输入内容筛选结果',
    entryHeading: '标题',
    entryOperation: '操作',
    entryTag: '标签',
    entryTagGroup: '标签组',
    entryWebhook: 'Webhook',
  },
  navigation: {
    introduction: '简介',
    closeGroup: '关闭分组',
    closeMenu: '关闭菜单',
    openGroup: '打开分组',
    openMenu: '打开菜单',
    operations: '操作',
    endpoints: '{name} 端点',
    showAllEndpoints: '显示 {name} 的所有端点',
    sidebarFor: '{name} 的侧边栏',
    mainContent: '{name} 的 API 文档',
    collapsed: '已折叠',
    webhooks: 'Webhooks',
    channels: '频道',
  },
  server: {
    label: '服务器',
    select: '选择服务器',
  },
  info: {
    termsOfService: '服务条款',
  },
  asyncapi: {
    servers: '服务器',
    protocols: '协议',
  },
  clientLibraries: {
    heading: '客户端库',
    more: '更多',
    selectAll: '从所有客户端中选择',
  },
  operation: {
    body: '请求体',
    cookies: 'Cookie',
    headers: '请求头',
    pathParameters: '路径参数',
    queryParameters: '查询参数',
    requestBody: '请求体',
    responses: '响应',
    testRequest: '测试请求',
    webhook: 'Webhook',
    selectedContentType: '已选内容类型',
    callbacks: '回调',
  },
  response: {
    exampleResponses: '响应示例',
    noBody: '无内容',
    showSchema: '显示 Schema',
    status: '状态',
  },
  schema: {
    noAllowedValues: '没有值满足此枚举约束。',
    example: '示例',
    examples: '示例',
    default: '默认值',
    schema: '架构',
    emptyObject: '空对象',
    showAdditionalProperties: '显示附加属性',
    forName: '对于 {name}',
    showSchemaDetails: '显示架构详情',
    oneOf: '其中一个',
    anyOf: '任意一个',
    allOf: '全部',
    not: '非',
    unknownType: '未知类型',
    propertyCount: '属性：{count}',
    headerCount: '标头：{count}',
    recursiveReference: '递归引用 {name}',
    recursive: '递归',
    additionalProperties: '附加属性',
    const: '常量',
    deprecated: '已弃用',
    discriminator: '鉴别器',
    enum: '枚举',
    format: '格式',
    greaterThan: '大于',
    keys: '键',
    lessThan: '小于',
    max: '最大值',
    min: '最小值',
    maxLength: '最大长度',
    minLength: '最小长度',
    multipleOf: '倍数',
    nullable: '可为 null',
    propertyNames: '属性名称',
    pattern: '模式',
    copyPattern: '复制模式',
    readOnly: '只读',
    required: '必填',
    hideValues: '隐藏值',
    showAllValues: '显示所有值',
    type: '类型',
    unique: '唯一',
    values: '值',
    writeOnly: '只写',
  },
  download: {
    openapi: '下载 OpenAPI 文档',
    asyncapi: '下载 AsyncAPI 文档',
  },
  models: {
    label: '模型',
  },
  actions: {
    copyAsMarkdown: '复制为 Markdown',
    copied: '已复制',
    copyMarkdownFailed: '无法复制 Markdown',

    copyLink: '复制链接',
    copyLinkTo: '复制指向 {name} 的链接',
    copyToClipboard: '复制链接到剪贴板',
    copyEndpointUrl: '复制端点 URL',
    showMore: '显示更多',
  },
  agent: {
    askAi: '询问 AI',
    askAiAgent: '询问 AI 助手',
    close: '关闭客户端',
  },
  mcp: {
    generate: '生成 MCP',
    connect: '连接 MCP',
  },
  developerTools: {
    title: '开发者工具',
    configure: '配置',
    share: '分享',
    deploy: '部署',
    scalarConfiguration: 'Scalar 配置',
    theme: '主题',
    layout: '布局',
    layoutOptions: '布局选项',
    intro: '开发者工具可用于自定义文档的外观和行为。你也可以通过 Scalar Registry 分享文档。',
    disableToolbarBefore: '要禁用工具栏，请在配置中设置',
    disableToolbarAfter: '。',
    localhostOnly: '开发者工具只会在 localhost 上运行时显示。',
    layoutModern: '现代',
    layoutClassic: '经典',
    showSidebar: '显示侧边栏',
    defaultOpenFirstTag: '默认打开第一个标签',
    defaultOpenAllTags: '默认打开所有标签',
    expandAll: '展开所有 {label}',
    expandAllResponses: '展开所有响应',
    hideClientButton: '隐藏客户端按钮',
    hideDarkModeToggle: '隐藏深色模式开关',
    hideModels: '隐藏 {label}',
    hideSearch: '隐藏搜索',
    showOperationId: '显示操作 ID',
    hideTestRequestButton: '隐藏测试请求按钮',
    scalarDocs: 'Scalar Docs',
    deployDescription: '将你的文档部署到 Scalar，这是适用于 API 等内容的现代文档平台。',
    shareTitle: '分享你的 API Reference',
    shareDescription: '上传 OpenAPI 文档，与其他人分享你的 API Reference。只需点击按钮即可。',
    uploadDocument: '上传文档',
    temporaryLinkExpiration: '你的文档将在 7 天后自动删除。',
    deployOnScalar: '部署到 Scalar',
    deployFree: '免费部署你的文档。',
    additionalFeaturesMightRequire: '其他功能可能需要',
    generate: '生成',
    passwordProtection: '密码保护',
    customDomains: '自定义域名',
    freeFormContent: '自由内容',
    cdnInfrastructure: 'CDN 基础设施',
    pullFromGitHub: '从 GitHub 拉取',
    markdownMdx: 'Markdown/MDX',
    spectralLinting: 'Spectral Linting',
    jsonSchemaHosting: 'JSON Schema 托管',
    askAi: '询问 AI',
    mcpServers: 'MCP 服务器',
    unableToExportDocument: '无法导出当前文档',
    unknownError: '发生未知错误',
  },
  gettingStarted: {
    swaggerEditor: 'Swagger Editor',
    description:
      '欢迎使用 Scalar API References + Swagger Editor，这是一款免费开源工具，可将你的 Swagger/OAS 文件生成精美的 API References。',
    showExample: '显示示例',
    uploadFile: '上传文件',
    integrations: '集成',
    theming: '主题',
    features: '功能',
    customize: '自定义',
    customizeDescription: '使用你的排版和调色板，或使用我们的主题！',
    testing: '测试',
    testingDescription: '深度集成的 REST API Client（同样免费且开源）',
    search: '搜索',
    searchDescription: '完整集成的搜索（使用 fuse.js）',
    hosting: '托管',
    hostingDescription: '在 https://apidocumentation.com 上免费托管子域名',
    openApiSwagger: 'OpenAPI 和 Swagger',
    openApiSwaggerDescription: '支持 OpenAPI 3.1、OpenAPI 3.0 和 Swagger 2.0',
    codeSamples: '代码示例',
    codeSamplesDescription: '用最流行语言展示你的 API 的代码示例',
  },
  footer: {
    poweredByScalar: '由 Scalar 提供支持',
  },
  authentication: {
    title: '身份验证',
    accepts: '接受',
    allOf: '全部：',
    authentication: '身份认证',
    optional: '身份认证可选',
    oneOf: '其中之一：',
    required: '需要身份认证',
    requires: '需要',
    scopes: 'OAuth 作用域',
  },
} satisfies ApiReferenceTranslations
